export const DomainType = [{ id: 'CITY', name: 'CITY' }]
